import { problemCode } from '@/lib/email-verification';

export const SUBSCRIPTION_REQUIRED = 'SUBSCRIPTION_REQUIRED';

export function isSubscriptionRequired(e: unknown): boolean {
  return (
    (e as { response?: { status?: number } } | null)?.response?.status === 403 &&
    problemCode(e) === SUBSCRIPTION_REQUIRED
  );
}

export function planRequiredMessage(canManageBilling: boolean): string {
  return canManageBilling
    ? 'This needs an active plan. Choose one under Billing.'
    : 'This needs an active plan. Ask the organization owner to choose one.';
}
